import { CardFooter } from "reactstrap";
import { H6, LI, P, UL } from "../../../../AbstractElements";
import { activeCoursesAverage } from "../../../../Constant";

const QuizResultsCardFooter = ({ quizScoresStats }) => {
  return (
    <CardFooter>
      <div className="d-flex align-items-center justify-content-center"><H6>{activeCoursesAverage}</H6></div>
      <UL attrUL={{ className: "d-sm-flex d-block simple-list flex-row " }}>
        {quizScoresStats?.map((course, index) => {
          return (
            <LI key={index}>
              <P attrPara={{ className: "f-w-600 font-primary f-12" }}>
              {`${course.courseName} (${course?.courseType})`}
              </P>
              <span className="f-w-700">{course?.percentage}%</span>
            </LI>
          )
        })}
      </UL>
    </CardFooter>
  );
};

export default QuizResultsCardFooter;